import { axios } from "../utils/request";
import { Log } from "../utils/debug";

export function apiGetRecaptchaID() {
    Log.debug("GET:/recaptcha");
    return axios.get("/recaptcha");
}

export function apiLogin(params) {
    Log.debug("POST:/login", params);
    return axios.post("/login", params);
}
